exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.base-layout[data-v-93a90936] {\n  color: #585859;\n}\n.base-layout .container-tit[data-v-93a90936] {\n  font-size: 22px;\n  color: #3C3C3D;\n  letter-spacing: 2.4px;\n  line-height: 22px;\n  margin-bottom: 45px;\n  margin-top: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-93a90936","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"javascriptEnabled":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Layout/baseLayout.vue
// module id = oPPq
// module chunks = 142